import React from "react";
import { NavBar, Icon } from "antd-mobile";
import {
  getTabledata,
  getheadermsg,
  getTabledatabycode,
  preView,
} from "../../ajax/index";

import { Link } from "react-router-dom";
import homeimg from "../../assets/images/home/icon_home_dark.png";
import { changeMeta } from "../../common/Method.js";
import { createHashHistory } from "history";
import { getLog } from "../../ajax/index.js";
const history = createHashHistory();
class errorCodeTable extends React.Component {
  constructor(porps) {
    super(porps);
    this.state = {
      Lampdata: [],
      Headerdata: [],
      id: "",
    };
  }

  componentDidMount() {
    //获取故障代码表头
    let params = this.props.match.params.listId.split(",");
    let listId = params[2];
    let buId = params[2];
    //获取故障代码表
    // if (listId === "p") {
    //   getTabledatabycode(params[0]).then((res) => {
    //     if (res.data && res.data.id) {
    //       this.setState({
    //         Headerdata: res.data,
    //         id: res.data.id,
    //       });
    //       getTabledata(res.data.id, params[1]).then((res) => {
    //         this.setState({
    //           Lampdata: res.data,
    //         });
    //       });
    //       let currentUrl = window.location.href;
    //       let appId = "tsp.errorcode";
    //       let pointName = `/errorCodelist`;
    //       getLog(currentUrl, appId, pointName);
    //     } else {
    //       history.push(`/systemerror`);
    //     }
    //   });
    // } else {
    let currentUrl = window.location.href;
    let appId = "tsp.errorcode";
    let pointName = `/errorCodelist`;
    getLog(currentUrl, appId, pointName);
    getheadermsg(params[0], params[1]).then((res) => {
      let Headerdata = res.data;
      console.log(Headerdata, "Headerdata");
      if (Headerdata.type == 0) {
        Headerdata.lamp1Name = "Fault Description";
        Headerdata.lamp2Name = "Reason";
      }
      this.setState({
        Headerdata: Headerdata,
      });
    });
    getTabledata(params[0], params[1], params[3]).then((res) => {
      let data = res.data || [];
      data.forEach((v) => {
        v.solution = v.solution || {};
      });
      this.setState({
        Lampdata: data,
      });
    });
    // }
  }
  back() {
    history.push("/");
  }
  //跳转到外链视频
  openVideo = (url) => {
    window.open(url);
  };
  preView = (id) => {
    preView(id).then((res) => {
      console.log(res, "preView");
      if (res.resultCode == "ISC-000") {
        window.open(res.data);
      }
    });
  };
  render() {
    changeMeta(this.props.match.path);
    let params = this.props.match.params.listId.split(",");
    let language = params[1];
    return (
      <div className="transition-item detail-page errorCodeTableWrap">
        <div className="menu-style">
          <NavBar
            mode="light"
            icon={<Icon key="0" type="left" />}
            onLeftClick={this.back}
            rightContent={[
              <Link key="2" to="/">
                <img
                  key="1"
                  src={homeimg}
                  width="24"
                  height="24"
                  alt="homeimg"
                />
              </Link>,
            ]}
          >
            Error Display
          </NavBar>
          <div className="display-list">
            <div className="table-style ">
              <div className="table-header sticky">
                <div className="flexbox ">
                  {this.state.Headerdata.type == 1 ? (
                    <div
                      className="box-border "
                      style={{ background: "#EDF2FF" }}
                    >
                      Display
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.Headerdata.lamp1Name ? (
                    <div className="box-border">
                      {this.state.Headerdata.lamp1Name}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.Headerdata.lamp2Name ? (
                    <div className="box-border">
                      {this.state.Headerdata.lamp2Name}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.Headerdata.lamp3Name ? (
                    <div className="box-border">
                      {this.state.Headerdata.lamp3Name}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.Headerdata.lamp4Name ? (
                    <div className="box-border">
                      {this.state.Headerdata.lamp4Name}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.Headerdata.lamp5Name ? (
                    <div className="box-border">
                      {this.state.Headerdata.lamp5Name}
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.Headerdata.lamp6Name ? (
                    <div className="box-border">
                      {this.state.Headerdata.lamp6Name}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="box-border max80">Solution</div>
                </div>
                {/* <div className=" box115"><div className="box-border">Solution</div></div> */}
              </div>
              <div className="table-body">
                {this.state.Lampdata.map((i, key) => {
                  let content = encodeURIComponent(i.solution.content);
                  return (
                    <div style={{ display: "flex" }}>
                      <div className="flexbox" key={key}>
                        {this.state.Headerdata.type == 1 ? (
                          <div className="box-border d-font ">
                            {i.code}
                            {i.solutionContent ? (
                              <div className="display-tip">
                                <div className="ant-tooltip-arrow"></div>
                                <div className="ant-tooltip-inner">
                                  {i.solutionContent}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        ) : (
                          ""
                        )}

                        {this.state.Headerdata.lamp1Name ? (
                          <div className="box-border">{i.lamp1}</div>
                        ) : (
                          ""
                        )}
                        {this.state.Headerdata.lamp2Name ? (
                          <div className="box-border">{i.lamp2}</div>
                        ) : (
                          ""
                        )}
                        {this.state.Headerdata.lamp3Name ? (
                          <div className="box-border">{i.lamp3}</div>
                        ) : (
                          ""
                        )}
                        {this.state.Headerdata.lamp4Name ? (
                          <div className="box-border">{i.lamp4}</div>
                        ) : (
                          ""
                        )}
                        {this.state.Headerdata.lamp5Name ? (
                          <div className="box-border">{i.lamp5}</div>
                        ) : (
                          ""
                        )}
                        {this.state.Headerdata.lamp6Name ? (
                          <div className="box-border">{i.lamp6}</div>
                        ) : (
                          ""
                        )}
                        <div className="box-border max80">
                          {i.solution.id === null ? (
                            ""
                          ) : (
                            <div>
                              {i.solution.docId ? (
                                <Link
                                  to={
                                    "/Solution/" +
                                    i.solutionId +
                                    "," +
                                    language +
                                    ",pdf," +
                                    i.solution.docId
                                  }
                                  className="a-btn a-btn-pdf"
                                ></Link>
                              ) : (
                                ""
                              )}
                              {i.solution.pictureId ? (
                                <Link
                                  to={
                                    "/Solution/" +
                                    i.solutionId +
                                    "," +
                                    language +
                                    ",png," +
                                    i.solution.pictureId
                                  }
                                  className="a-btn a-btn-png"
                                ></Link>
                              ) : (
                                ""
                              )}
                              {i.solution.videoId ? (
                                <Link
                                  to={
                                    "/Solution/" +
                                    i.solutionId +
                                    "," +
                                    language +
                                    ",video," +
                                    i.solution.videoId
                                  }
                                  className="a-btn a-btn-video"
                                ></Link>
                              ) : i.solution.url ? (
                                <span
                                  className="a-btn a-btn-video"
                                  onClick={() => {
                                    this.openVideo(i.solution.url);
                                  }}
                                ></span>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* <div className=" box115">
                          <div className="box-border">{i.solutionName === null ? "" : <Link to={"/Solution/" + i.solutionId} className="a-btn">{i.solutionName}</Link>}</div>
                        </div> */}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default errorCodeTable;



// WEBPACK FOOTER //
// ./src/pages/Home/errorCodeTable.js